/* eslint-disable filename-export/match-default-export */
import { useMemo } from 'react';
import { generateId } from '../index';
import useValidatorLookup from './use-validator-lookup';

export default function useValidators({ validators }) {
  const uuid = useMemo(() => generateId(), []);
  const { addValidators } = useValidatorLookup({ uuid });

  addValidators({ uuid, validators });

  return {
    uuid,
  };
}
